/*
 * direct.js
 *
 * Description: Holds 'Stores' Logic for Module:'Direct'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020,2021 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> 'Bookingno for Direct' -------------------------
    flag_DirectShowBookingnoSearchResults: false, // 'Direct Get Booking' done

    // >>> 'Direct' ---------------------------------------
    directGetBooking2Results: {}, // SearchResults (Direct - Getbooking2)

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Bookingno Direct', Control Flags
    ***************************************************************************/
    /***************************************************************************
    * get_FlagDirectShowBookingnoSearchResults()
    *
    * Desc: Return Flag: 'Show Bookingno Direct Overview Section'
    * Note:
    *
    */
    get_FlagDirectShowBookingnoSearchResults: state => {

        return state.flag_DirectShowBookingnoSearchResults;

    }, // eo function get_FlagDirectShowBookingnoSearchResults()


    /***************************************************************************
    * get_DirectOriginalBookingHasOutwardFlight()
    *
    * Desc: Return if original Booking has an 'Outward Flight'?
    * Note:
    *
    */
    get_DirectOriginalBookingHasOutwardFlight: state => {

        let outwardFlightInOriginalBooking = false;


        if (state.directGetBooking2Results.outwardFlights.length > 0) {
            outwardFlightInOriginalBooking = true;
        } else {
            outwardFlightInOriginalBooking = false;
        }


        return outwardFlightInOriginalBooking;

    }, // eof get_DirectOriginalBookingHasOutwardFlight()


    /***************************************************************************
    * get_DirectOriginalBookingHasReturnFlight()
    *
    * Desc: Return if original Booking has a 'Inbound Flight'?
    * Note:
    *
    */
    get_DirectOriginalBookingHasReturnFlight: state => {

        let returnFlightInOriginalBooking = false;


        if (state.directGetBooking2Results.inboundFlights.length > 0) {
            returnFlightInOriginalBooking = true;
        } else {
            returnFlightInOriginalBooking = false;
        }


        return returnFlightInOriginalBooking;

    }, // eof get_DirectOriginalBookingHasReturnFlight()


    /***************************************************************************
    * get_GotFlightsToDirect()
    *
    * Desc: Returns
    * Note: payload: { flightdirection: flightdirection' }
    * Note:
    *
    */
    get_GotFlightsToDirect: state => payload => {

        let gotFlightsToRebook = false;


        // >>> Tickets from Call: 'getbooking' ------------
        if (payload.flightdirection === 'outward') {
            state.directGetBooking2Results.outwardFlights.forEach((flight, i) => {
                if (flight.rebookable === true) {
                    gotFlightsToRebook = true;
                }
            });
        }

        if (payload.flightdirection === 'return') {
            state.directGetBooking2Results.inboundFlights.forEach((flight, i) => {
                if (flight.rebookable === true) {
                    gotFlightsToRebook = true;
                }
            });
        }


        return gotFlightsToRebook;

    }, // eo function get_GotFlightsToDirect()


    /***************************************************************************
    * get_DirectOriginalBookingRebookingFee()
    *
    * Desc: Return 'rebookingFee' from original Booking.
    * Note:
    *
    */
    get_DirectOriginalBookingRebookingFee: state => {

        return Number(state.directGetBooking2Results.rebookingFee);

    }, // eof get_DirectOriginalBookingRebookingFee()


    /***************************************************************************
    * get_DirectTickets()
    *
    * Desc: Returns Pax List with its Services.
    * Note: payload: { idFlight: flight.idFlight, whichCall: 'getbooking' }
    * Note: Possible whichCall(s): 'getbooking', 'getrebookingkey'
    *
    */
    get_DirectTickets: state => payload => {

        let paxSrvcsList = [];


        // >>> Tickets from Call: 'getbooking' ------------
        if (payload.whichCall === 'getbooking') {
            state.directGetBooking2Results.tickets.forEach((ticket, i) => {
                if (ticket.idFlight === payload.idFlight) {
                    state.directGetBooking2Results.passengers.forEach((pax, i) => {
                        if (ticket.idPax === pax.idPax) {
                            paxSrvcsList.push({
                                pax: pax,
                                ticket: ticket
                            });
                        }
                    });
                }
            });
        }

        // >>> Tickets from Call: 'getrebookingkey' ------------
        if (payload.whichCall === 'getrebookingkey') {
            state.directGetBooking2Results.tickets.forEach((ticket, i) => {
                if (ticket.idFlight === payload.idFlight) {
                    state.directGetBooking2Results.passengers.forEach((pax, i) => {
                        if (ticket.idPax === pax.idPax) {
                            paxSrvcsList.push({
                                pax: pax,
                                ticket: ticket
                            });
                        }
                    });
                }
            });
        }


        return paxSrvcsList;

    }, // eo function get_DirectTickets()




    /***************************************************************************
    * Actions: 'Add Infant' (Direct only)
    ***************************************************************************/
    /***************************************************************************
    * get_DirectGetBooking2Results()
    *
    * Desc:
    * Note:
    *
    */
    get_DirectGetBooking2Results: state => {

        return state.directGetBooking2Results;

    }, // eof get_DirectGetBooking2Results()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: 'Bookingno Direct', Control Flags
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagDirectShowBookingnoSearchResults()
    *
    * Desc: SET State/Flag 'Show Bookinno Overview Section'
    * Note: CONTROL FLAG
    *
    */
    mut_FlagDirectShowBookingnoSearchResults: (state, payload) => {

        state.flag_DirectShowBookingnoSearchResults = payload;

    }, // eof mut_FlagDirectShowBookingnoSearchResults()




    /***************************************************************************
    * Actions: 'Add Infant' (Direct only)
    ***************************************************************************/
    /***************************************************************************
    * mut_call_getBooking2()
    *
    * Desc: SET State 'getbooking2' Object. Direct - Add Infant.
    * Note: Sort here: ADT => CHD
    *
    */
    mut_call_getBooking2: (state, payload) => {

        payload.tickets.forEach((item, i) => {
            if (item.child === true) {
                item.order = 2;
            }
            if (item.child === false) {
                item.order = 1;
            }
        });

        payload.tickets.sort(function (a, b) {
            return a.order - b.order;
        });


        state.directGetBooking2Results = payload;

    }, // eo function mut_call_getBooking2()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: 'Bookingno Direct', Control Flags
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagDirectShowBookingnoSearchResults()
    *
    * Desc: ACTION 'Show Bookinno Direct Overview Section'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagDirectShowBookingnoSearchResults: (context, payload) => {

        context.commit('mut_FlagDirectShowBookingnoSearchResults', payload); // calling mutation

    }, // eo function actn_FlagDirectShowBookingnoSearchResults()




    /***************************************************************************
    * Actions: 'Change FLight' (Direct only)
    ***************************************************************************/
    /***************************************************************************
    * Call::'/rest/rebooking/changeflight/id/id'
    *
    * Desc: (Call) - Change Flight.
    * Note:
    *
    */
    actn_call_changeFlight: (context, payload) => {

        let hdrs = '',
            trsnltd = '';



        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.get('/rebooking/changeflight/' + payload.flightid1 + '/' + payload.flightid2)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        Vue.prototype.$toasted.global.sdr_app_info({
                            message: 'Swap was successful.'
                        });
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_changeFlight()




    /***************************************************************************
    * Actions: 'Get Booking2' (Direct only)
    ***************************************************************************/
    /***************************************************************************
    * Call::'rest/rebooking/getbooking2'
    *
    * Desc: (Call) - Get Booking.
    * Note:
    *
    */
    actn_call_getBooking2: (context, payload) => {

        let hdrs = '',
            trsnltd = '';



        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/rebooking/getbooking2/', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('readytoshowbookingforaddinfant'); // emit .. 'ready to push 'passengers''
                        context.commit('mut_call_getBooking2', response.data);
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getBooking2()




    /***************************************************************************
    * Actions: 'Add Infant' (Direct only)
    ***************************************************************************/
    /***************************************************************************
    * Call::'/acm/invoices/addinfant'
    *
    * Desc: (Call) - Add Infant to Ticket.
    * Note:
    *
    */
    actn_call_addInfant: (context, payload) => {

        let hdrs = '',
            trsnltd = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/acm/invoices/addinfant', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('readytoshowaddinfantwassuccessful'); // emit ..
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_addInfant()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};